var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vfdv2",class:[
    { 'vfdv2-clickable': _vm.clickable },
    { 'vfdv2-custom': _vm.customContent },
    { 'vfdv2-nopad': _vm.noPadding } ],on:{"click":_vm.onClick}},[(_vm.header)?_c('div',{staticClass:"vfdv2-header"},[(_vm.header)?_c('div',{staticClass:"vfdv2-header-x"},[_vm._v(" "+_vm._s(_vm.header)+" ")]):_vm._e(),(_vm.header)?_c('div',{staticClass:"vfdv2-header-z"}):_vm._e()]):_vm._e(),_c('div',{staticClass:"vfdv2-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }